import { z } from 'zod';

import { PaymentDeferralWorkoutPlan } from '../../../loan/WorkoutPlan';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CreatePaymentDeferralWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('createPaymentDeferralWorkoutPlan'),
  data: PaymentDeferralWorkoutPlan.pick({
    reason: true,
    endDate: true, // offer expiration date
    startStatementDate: true,
    endStatementDate: true,
    chargeIds: true,
    paymentDueIds: true,
    excludedPastDuePaymentDueIds: true,
    excludedPastDueAmount: true,
    totalDeferredBalance: true,
    quotedDeferredBalances: true,
    acceptanceMethod: true,
    acceptanceMethodOther: true,
  }),
});
export type CreatePaymentDeferralWorkoutPlanEvent = z.infer<typeof CreatePaymentDeferralWorkoutPlanEvent>;
